
import React, { useEffect } from "react";



import "./Footer.css";

// import ImprintDataPrivacyContact  from "./ImprintDataPrivacyContact";

import { useStateValue } from "../StateProvider";
import { clearStoredToken } from "../spotify";
import { signOut } from 'firebase/auth';
import { authV9 as auth } from "../firebase";
import { Link } from "react-router-dom";



function Footer() {
  const [{ token, firebaseUser }, dispatch] = useStateValue();



  useEffect(() => {
    //this is where the code runs once, wenn am schluss [] leer ist

      //every time a new post is added, this code is fired



    }, [] );


    // Logout from Song Carousel (Firebase Auth)
    const handleLogoutFromApp = async (e) => {
      e.stopPropagation(); // Prevent footer click event

      try {
        await signOut(auth);
        // User will be redirected by App.js auth state listener
      } catch (err) {
        console.error("Logout error:", err);
      }
    };

    // Disconnect Spotify (clear Spotify token but keep Firebase auth)
    function handleDisconnectSpotify(e) {
      e.stopPropagation(); // Prevent footer click event

      // Clear Spotify token and related data
      clearStoredToken();
      localStorage.removeItem('countUserRatings');
      sessionStorage.removeItem('songCarouselSessionStart');

      // Clear token from state
      dispatch({
        type: "SET_TOKEN",
        token: null,
      });

      // Reload to show connect screen
      window.location.href = '/';
    }








  return (
    <div className="footer">

{/* <SpotifyPlayer
  token={token}
//als array für alles von artist uris={['spotify:artist:6HQYnRM4OzToCYPpVBInuU']}
name={"Songcarousel Player"}
uris={`spotify:track:${songToPlay}`}
styles={{
  activeColor: '#fff',
  bgColor: '#fff',
  color: '#fff',
  loaderColor: '#fff',
  sliderColor: '#1cb954',
  trackArtistColor: '#797979',
  trackNameColor: '#000',
}}


/>  */}


<Link to="/imprint" className="footer-link-plain">Imprint</Link>&nbsp;|&nbsp;
<Link to="/imprint" className="footer-link-plain">Privacy Policy</Link>&nbsp;|&nbsp;
<Link to="/imprint" className="footer-link-plain">Contact</Link>
{firebaseUser && (
  <>
    &nbsp;|&nbsp;
    <button
      type="button"
      onClick={handleLogoutFromApp}
      style={{
        fontSize: '15px',
        color: '#ffb6c1',
        background: 'none',
        border: 'none',
        padding: '0',
        textDecoration: 'underline',
        cursor: 'pointer'
      }}
    >
      Logout from Song Carousel
    </button>
    {token && (
      <>
        &nbsp;|&nbsp;
        <button
          type="button"
          onClick={handleDisconnectSpotify}
          style={{
            fontSize: '15px',
            color: '#ffb6c1',
            background: 'none',
            border: 'none',
            padding: '0',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
        >
          Disconnect Spotify
        </button>
      </>
    )}
  </>
)}
&nbsp;&nbsp;v 5.25

    </div>
  );





}





export default Footer;
